import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faClock } from '@fortawesome/free-solid-svg-icons'
import LeftBar from '../Components/LeftBar'
import BottomNav from '../Components/BottomNav'
import Topbar from '../Components/Topbar'
import '../VerifyAcc.css'
import { app } from "../firebase.js"
import { getAuth } from "firebase/auth"
import {
  doc,
  getDoc,
  getFirestore,
  updateDoc,
  addDoc,
  collection,
  serverTimestamp,
  Timestamp
} from "firebase/firestore"
import swal from 'sweetalert'
import { ToastContainer, toast, Bounce } from 'react-toastify'
import { Modal, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'

import SocialCardModal from '../Components/SocialCardModal.js'


function VerifyAccount() {
  const auth = getAuth()
  const db = getFirestore(app)

  const [loading, setLoading] = useState(true)
  const [userId, setUserId] = useState("")
  const [loggedInUserName, setLoggedInUserName] = useState("")
  const [userName, setUserName] = useState("")
  const [infName, setInfName] = useState("");

  const [phoneNumber, setPhoneNumber] = useState("")
  const [otp, setOtp] = useState("")
  const [generatedOtp, setGeneratedOtp] = useState("")
  const [isPhoneVerified, setIsPhoneVerified] = useState(false)

  const [subscriptionEnabled, setSubscriptionEnabled] = useState(false)
  const [duration, setDuration] = useState("")
  const [subscriptionExpiry, setSubscriptionExpiry] = useState(null)
  const [isSubscriptionActive, setIsSubscriptionActive] = useState(false)

  const [showPaymentModal, setShowPaymentModal] = useState(false)
  const [mpesaNumber, setMpesaNumber] = useState("")
  const [paying, setPaying] = useState(false)

  const [socials, setSocials] = useState({})
  const [verifiedSocials, setVerifiedSocials] = useState({})
  const [socialForms, setSocialForms] = useState({})
  const [userProfile, setUserProfile] = useState({ profilePhoto: null, coverPhoto: null, countryName: null })

  const MONTHLY_FEE = 1000
  const totalAmount = duration ? Number(duration) * MONTHLY_FEE : 0
  const baseUrl = "https://us-central1-zindua-ke.cloudfunctions.net/paymentApi"

  // At the top of the component
  const [showSocialModals, setShowSocialModals] = useState({});

  useEffect(() => {
    document.title = "Zindua App | Dashboard";

    // Meta description
    let desc = document.querySelector("meta[name='description']");
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute("content", "Zindua App dashboard");

    // Open Graph tags
    const ogTags = [
      { property: "og:title", content: "Zindua App | Dashboard" },
      { property: "og:description", content: "Zindua App Dashboard" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://zindua.app/dashboard" },
      { property: "og:image", content: "https://zindua.app/logo192.png" },
    ];

    ogTags.forEach(({ property, content }) => {
      let tag = document.querySelector(`meta[property='${property}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    });

    // JSON-LD structured data
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Zindua App Influencer Dashboard",
      "url": "https://zindua.app/dashboard",
      "description": "Zindua App influencer dashboard where you can manage your earnings, running ads, subscriptions, and withdraw funds to M-Pesa.",
      "inLanguage": "en",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://zindua.app/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Dashboard",
            "item": "https://zindua.app/dashboard"
          }
        ]
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged(async user => {
      if (!user) {
        setLoading(false)
        return
      }

      const snap = await getDoc(doc(db, "users", user.uid))
      if (!snap.exists()) {
        setLoading(false)
        return
      }

      const data = snap.data()


      setUserId(user.uid)
      setLoggedInUserName(data.userName || "")
      setUserName(data.theUsername || "")

      setInfName(data.userName || "")
      setPhoneNumber(data.mpesaNumber || "")
      setMpesaNumber(data.mpesaNumber || "")
      setIsPhoneVerified(data.isPhoneVerified || false)
      setSubscriptionEnabled(data.subscriptionEnabled || false)
      setSocials(data.socials || {})
      setVerifiedSocials(data.verifiedSocials || {})

      setUserProfile({
        profilePhoto: data.profileImage || null,
        coverPhoto: data.coverImage || null,
        country: data.countryName || "Unknown",
        profileLink: data.theUsername
      });
      const expiry = data.subscriptionExpiry
        ? data.subscriptionExpiry.toDate()
        : null

      setSubscriptionExpiry(expiry)
      setIsSubscriptionActive(expiry && expiry > new Date())
      setLoading(false)
    })

    return () => unsub()
  }, [auth, db])

  // async function sendOtp() {
  //   if (!phoneNumber) {
  //     toast.error("Phone number missing")
  //     return
  //   }

  //   const newOtp = Math.floor(100000 + Math.random() * 900000)
  //   setGeneratedOtp(newOtp)

  //   try {
  //     const token = await auth.currentUser.getIdToken()

  //     await fetch(
  //       "https://us-central1-zindua-ke.cloudfunctions.net/commapi/send-sms",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`
  //         },
  //         body: JSON.stringify({
  //           phoneNumber,
  //           message: `Your OTP code is ${newOtp}`
  //         })
  //       }
  //     )

  //     toast.success("OTP sent to your phone")
  //   } catch {
  //     toast.error("Failed to send OTP")
  //   }
  // }

  // async function verifyOtp() {
  //   if (!otp || Number(otp) !== Number(generatedOtp)) {
  //     toast.error("Incorrect OTP")
  //     return
  //   }

  //   await updateDoc(doc(db, "users", userId), {
  //     isPhoneVerified: true
  //   })

  //   setIsPhoneVerified(true)
  //   toast.success("Phone number verified")
  // }

  const activeSocials = Object.entries(socials)
    .filter(([_, value]) => value === "selected")
    .map(([key]) => key)

  function handleSocialChange(platform, field, value) {
    setSocialForms(prev => ({
      ...prev,
      [platform]: {
        ...prev[platform],
        [field]: value
      }
    }))
  }

  async function submitSocialVerification(platform) {
    const form = socialForms[platform]

    if (!form?.method || !form?.postUrl) {
      toast.error("Select a verification method and paste the post link")
      return
    }

    const payload = {
      platform,
      method: form.method,
      postUrl: form.postUrl,
      status: "pending",
      submittedAt: serverTimestamp(),
      reviewedAt: null
    }

    try {
      await updateDoc(doc(db, "users", userId), {
        [`verifiedSocials.${platform}`]: payload
      })

      setVerifiedSocials(prev => ({
        ...prev,
        [platform]: payload
      }))

      toast.success("Submitted for verification")
    } catch {
      toast.error("Failed to submit verification")
    }
  }

  // Add these new state variables at the top
  const [pollingTimeLeft, setPollingTimeLeft] = useState(0); // seconds left for countdown
  const [paymentRetries, setPaymentRetries] = useState(0);   // tracks auto-retries

  async function handlePayment() {
    if (!duration) {
      toast.error("Select a subscription duration");
      return;
    }

    if (!mpesaNumber) {
      toast.error("Enter your M-Pesa number");
      return;
    }

    setPaying(true);
    setPollingTimeLeft(120); // 3 minutes countdown
    setShowPaymentModal(true); // ensure modal is visible

    // Format phone for M-Pesa
    let phone = mpesaNumber.replace(/\D/g, ""); // remove spaces/symbols
    if (phone.startsWith("0")) phone = "254" + phone.slice(1);

    try {
      // Trigger M-Pesa payment
      const transactionId = await sendPayment(phone);

      if (!transactionId) {
        // First attempt failed → retry automatically once
        if (paymentRetries === 0) {
          setPaymentRetries(1);
          toast.info("Retrying payment...");
          return handlePayment(); // auto retry
        } else {
          throw new Error("Payment failed after retry");
        }
      }

      toast.info("Payment initiated. Please approve on your phone.");

      // Start countdown
      const countdownInterval = setInterval(() => {
        setPollingTimeLeft(prev => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      // Poll payment status every 5 seconds for 3 minutes
      const pollPaymentStatus = async (retries = 36) => {
        try {
          const res = await fetch(`${baseUrl}/verify-payment/${transactionId}`);
          const data = await res.json();
          const transaction = data?.data?.data?.transaction?.[0];

          if (transaction?.status === "success") {
            clearInterval(countdownInterval);
            await recordPayment(transactionId);
            toast.success("Payment successful! Subscription activated.");
            setShowPaymentModal(false);
            setPaying(false);
            setPaymentRetries(0);
            return;
          }

          if (retries > 0) {
            setTimeout(() => pollPaymentStatus(retries - 1), 5000);
          } else {
            toast.error("Payment not confirmed. Check your M-Pesa and retry.");
            setPaying(false);
            setPaymentRetries(0);
          }
        } catch {
          if (retries > 0) setTimeout(() => pollPaymentStatus(retries - 1), 5000);
          else {
            toast.error("Failed to verify payment. Try again.");
            setPaying(false);
            setPaymentRetries(0);
          }
        }
      };

      pollPaymentStatus();
    } catch (err) {
      console.error("Payment error:", err);
      toast.error(err.message || "Payment initiation failed. Try again.");
      setPaying(false);
      setPaymentRetries(0);
    }
  }

  // Helper: trigger the payment on server
  async function sendPayment(phone) {
    try {
      const res = await fetch(`${baseUrl}/make-payment`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: totalAmount,
          contact_phone_number: phone,
          contact_name: loggedInUserName,
          description: "Subscription payment"
        })
      });
      const data = await res.json();
      return data?.data?.data?.transaction?.id || null;
    } catch {
      return null;
    }
  }

  // Record payment to Firestore
  async function recordPayment(transactionId) {
    const paidAt = new Date();
    const expiryDate = new Date();
    expiryDate.setMonth(expiryDate.getMonth() + Number(duration));

    await addDoc(collection(db, "payments"), {
      userId,
      amount: totalAmount,
      months: Number(duration),
      mpesaNumber,
      transactionId,
      status: "paid",
      paidAt: Timestamp.fromDate(paidAt),
      expiryDate: Timestamp.fromDate(expiryDate),
      createdAt: serverTimestamp()
    });

    await updateDoc(doc(db, "users", userId), {
      subscriptionPaid: true,
      subscriptionPaidAt: Timestamp.fromDate(paidAt),
      subscriptionExpiry: Timestamp.fromDate(expiryDate),
      acceptingSubs: true
    });

    setIsSubscriptionActive(true);
    setSubscriptionExpiry(expiryDate);
  }


  const [showSocialCard, setShowSocialCard] = useState(false)



  return (
    <div className="mainDashboard">
      <div className="desktopOnly">
        <LeftBar />
      </div>

      <div className="mainContent">
        <Topbar />

        <section className="verifyAccContainer">
          <h3 className="verifyAccTitle">Account Verification</h3>

          {/* <div className="verifyAccCard">
            <h5>1. Phone Number</h5>

            {isPhoneVerified ? (
              <div className="verifyAccVerified">
                <FontAwesomeIcon icon={faCheckCircle} /> Phone number is already verified
              </div>
            ) : (
              <>
                <input className="verifyAccInput" value={phoneNumber} disabled />
                <button className="verifyAccPrimaryBtn verifyAccMt8" onClick={sendOtp}>
                  Send OTP
                </button>

                <input
                  className="verifyAccInput verifyAccMt8"
                  placeholder="Enter OTP"
                  value={otp}
                  onChange={e => setOtp(e.target.value)}
                />

                <button className="verifyAccSuccessBtn verifyAccMt8" onClick={verifyOtp}>
                  Verify phone number
                </button>
              </>
            )}
          </div> */}

          <div className="verifyAccCard">
            <h5>1. Profile and Cover Photos</h5>
            {loading ? (
              <p>Loading...</p>
            ) : (
              <>
                {userProfile?.profilePhoto && userProfile?.coverPhoto ? (
                  <p className='small'><FontAwesomeIcon icon={faCheckCircle} /> Cover photo and profile photo are already uploaded</p>
                ) : (
                  <p className='small'>
                    You do not have a profile or cover photo yet.{' '}
                    <Link to="/edit-profile">Upload now</Link>
                  </p>
                )}
              </>
            )}
          </div>


          <div className="verifyAccCard">
            <h5>2. Verify Social Ownership</h5>

            {activeSocials.length > 0 && (
              <div>
                <p className="verifyAccMuted">
                  Create a post telling your followers that you accept ads on Zindua.
                  Use the provided verification media, create your own post, or share a short video.

                  <br />

                </p>
                <div className='alert alert-primary small'>
                  If you use the verification media, download it and post it. In the post caption, include your Zindua profile link: <a href={`https://zindua.app/${userName}`} target="_blank" rel="noopener noreferrer">
                    https://zindua.app/{userName}
                  </a>
                </div>

              </div>
            )}

            {activeSocials.length === 0 && (
              <p className="verifyAccMuted">No active social accounts selected.</p>
            )}




            {activeSocials.map(platform => {
              const status = verifiedSocials?.[platform]?.status;
              const form = socialForms[platform] || {};

              const showModal = showSocialModals[platform] || false;

              return (
                <div key={platform} className="verifyAccMt16">
                  <label className="verifyAccLabel">
                    Verify {platform.charAt(0).toUpperCase() + platform.slice(1)}
                  </label>

                  {status === "pending" && (
                    <div className="verifyAccPending">
                      <FontAwesomeIcon icon={faClock} /> Pending review
                    </div>
                  )}

                  {status === "verified" && (
                    <div className="verifyAccVerified">
                      <FontAwesomeIcon icon={faCheckCircle} /> Verified
                    </div>
                  )}

                  {!status && (
                    <>
                      <br />
                      <p className='small'>Choose how you want to verify your {platform.charAt(0).toUpperCase() + platform.slice(1)} account</p>

                      <select
                        className="verifyAccInput"
                        onChange={e =>
                          handleSocialChange(platform, "method", e.target.value)
                        }
                      >
                        <option value="">Select method</option>
                        <option value="image">Posted verification media</option>
                        <option value="poster">Created own post</option>
                        <option value="video">Posted a short video</option>
                      </select>


                      <button
                        className="btnSignUpHero55"
                        onClick={() =>
                          setShowSocialModals((prev) => ({ ...prev, [platform]: true }))
                        }
                      >
                        View verification media
                      </button>
                      <br /> <br />

                      <p>Paste the link to the post below. We verify accounts within 2 hours.</p>

                      <SocialCardModal
                        show={showModal}
                        onHide={() =>
                          setShowSocialModals(prev => ({ ...prev, [platform]: false }))
                        }
                        userProfile={userProfile}
                        infName={infName}
                      />

                      <input
                        className="verifyAccInput verifyAccMt8"
                        placeholder={`Paste ${platform} post link`}
                        onChange={e =>
                          handleSocialChange(platform, "postUrl", e.target.value)
                        }
                      />

                      <button
                        className="verifyAccSuccessBtn verifyAccMt8"
                        onClick={() => submitSocialVerification(platform)}
                      >
                        Submit for verification
                      </button>
                    </>
                  )}
                </div>
              );
            })}


          </div>

          {subscriptionEnabled && (
            <div className="verifyAccCard">
              <h5>3. Subscription (Optional)</h5>


              {isSubscriptionActive ? (
                <div className="verifyAccVerified">
                  <FontAwesomeIcon icon={faCheckCircle} /> Subscription is active
                  {subscriptionExpiry && (
                    <div className="verifyAccMuted">
                      Expires on {subscriptionExpiry.toLocaleDateString()}
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <div className='alert alert-primary small mt-2 mb-2'>
                    This allows you to accept subscriptions. We charge a flat rate of KES 1,000 per month instead of a 20% commission on all subscriptions. If you don't need subscriptions, you can disable them on the Edit Account page.
                  </div>


                  <select
                    className="verifyAccInput"
                    value={duration}
                    onChange={e => setDuration(e.target.value)}
                  >
                    <option value="1">Select duration</option>
                    <option value="1">1 month</option>
                    <option value="6">6 months</option>
                    <option value="12">1 year</option>
                  </select>

                  <div className="verifyAccPriceBox verifyAccMt8">
                    <span>Total</span>
                    <strong>KES {totalAmount.toLocaleString()}</strong>
                  </div>

                  <button
                    className="verifyAccPrimaryBtn verifyAccMt8"
                    onClick={() => setShowPaymentModal(true)}
                  >
                    Pay and activate
                  </button>
                </>
              )}
            </div>
          )}
        </section>
      </div>

      <div className="mobileOnly">
        <BottomNav />
      </div>

      <Modal
        show={showPaymentModal}
        onHide={() => { }} // disable closing
        centered
        backdrop="static" // prevent outside click
        keyboard={false}   // prevent ESC
      >
        <Modal.Header>
          <Modal.Title>Pay with M-Pesa</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          <input
            className="verifyAccInput mb-3"
            placeholder="07XXXXXXXX"
            value={mpesaNumber}
            onChange={e => setMpesaNumber(e.target.value)}
            disabled={paying}
          />

          <div className="verifyAccPriceBox mb-3">
            <span>Total</span>
            <strong>KES {totalAmount.toLocaleString()}</strong>
          </div>

          {paying && (
            <>
              <Spinner animation="border" variant="primary" role="status" />
              <p className="mt-2">
                Waiting for STK approval... {pollingTimeLeft}s remaining
              </p>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="primary"
            disabled={paying || !mpesaNumber}
            onClick={handlePayment}
          >
            {paying ? "Processing..." : "Confirm and pay"}
          </Button>
        </Modal.Footer>
      </Modal>


      <ToastContainer theme="dark" transition={Bounce} />
    </div>
  )
}

export default VerifyAccount